import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _pick from "lodash/pick";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import fetchAPI from 'utils/http/fetchAPI';
import { SAMPLES_FILE_UPDATE } from 'redux/actionTypes/samples';
import UploadStatus from 'utils/upload/UploadStatus';
import updateSampleFileUpload from 'redux/actions/samples/updateSampleFileUpload';
var createSampleFile = function createSampleFile(experimentId, sampleId, type, file, abortController) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var updatedAt, sampleFileId, _url, _body, _fileForRedux;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              updatedAt = dayjs().toISOString();
              sampleFileId = uuidv4();
              _context.prev = 2;
              _url = "/v2/experiments/".concat(experimentId, "/samples/").concat(sampleId, "/sampleFiles/").concat(type);
              _body = {
                sampleFileId: sampleFileId,
                size: file.size
              }; // Leaving out path, errors
              // They are used during the upload process, not redux
              // TODO we should check if they can be separated somehow between
              // The ones that are relevant for the api vs
              // the ones that are only necessary for retry (fileObject, compressed)
              // Perhaps into an uploadRetryParams object or something
              _fileForRedux = _pick(file, ['size', 'upload', 'fileObject', 'compressed']);
              dispatch({
                type: SAMPLES_FILE_UPDATE,
                payload: {
                  sampleUuid: sampleId,
                  sampleFileType: type,
                  lastModified: updatedAt,
                  fileDiff: _objectSpread(_objectSpread({}, _fileForRedux), {}, {
                    upload: {
                      status: UploadStatus.UPLOADING,
                      progress: 0,
                      abortController: abortController
                    }
                  })
                }
              });
              _context.next = 9;
              return fetchAPI(_url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_body)
              });
            case 9:
              return _context.abrupt("return", _body.sampleFileId);
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              dispatch(updateSampleFileUpload(experimentId, sampleId, sampleFileId, type, UploadStatus.UPLOAD_ERROR));
              throw _context.t0;
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default createSampleFile;